import PropTypes from 'prop-types';
import React from 'react';
import ToGradeRow from '../ToGradeRow';

const AnswersContainer = ({
  answers,
  currentUser,
  practiceQuestionAnswers,
  setGradedAnswers,
  ziggeoApiKey,
}) => {
  const sectionHeader = () => {
    const string = practiceQuestionAnswers
      ? t('grades.question_type.practice')
      : t('grades.question_type.non_practice');
    return string.toUpperCase();
  };

  return (
    <section className="mt-32">
      <div className="d-f jc-sb mb-16">
        <div className="c-brand-gray-dark fw-b fz-16">{sectionHeader()}</div>
      </div>
      <div className="d-f w-fill border border-gray-light bg-gray-lighter fz-16 fw-b p-12">
        <span className="w-25p ml-24">
          {practiceQuestionAnswers
            ? t('common.prompt')
            : t('progress.report_card.question')}
        </span>
        <span className="w-25p">
          {practiceQuestionAnswers
            ? t('grades.given_response')
            : t('progress.report_card.given_answer')}
        </span>
        <span className="w-20p">
          {t('questions.grader_notes.instructions')}
        </span>
        <span className="w-25p">
          {t('progress.report_card.grading_feedback')}
        </span>
      </div>
      {answers.map(answer => (
        <ToGradeRow
          answer={answer}
          currentUser={currentUser}
          key={`answer_${answer.id}`}
          setGradedAnswer={setGradedAnswers(answer.id)}
          ziggeoApiKey={ziggeoApiKey}
        />
      ))}
    </section>
  );
};

AnswersContainer.propTypes = {
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      answer: PropTypes.shape({
        id: PropTypes.number,
      }),
    }),
  ),
  currentUser: PropTypes.string,
  ziggeoApiKey: PropTypes.string,
};

export default AnswersContainer;
